export default __webpack_public_path__ + "static/media/device_issue.edc5bbc7.png";